import { map, tap } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { ClevertapEventsService } from "../services/clevertap.service";
import { SessionService } from "../services/session.service";
import * as JSZip from "jszip";
import * as FileSaver from "file-saver";
import { ToasterService } from "angular2-toaster";
import * as moment from "moment";

import { HttpClient, HttpParams } from "@angular/common/http";
import {
  ApplicationEntityModel,
  CandidateEntityModel,
  CandidatesEntityModel,
  JobOffer,
} from "../interfaces";
import { V3JobsResponse } from "app/interfaces/v3-jobs-response.entity";
import { DP_FORMAT } from "app/views/jobOffers/edit-join-offer/exports";

@Injectable({
  providedIn: "root",
})
export class JobOffersService {
  massiveDownload: BehaviorSubject<{ label: string; loading: boolean }> =
    new BehaviorSubject<{ label: string; loading: boolean }>({
      label: "Download",
      loading: false,
    });

  massiveDownloadEnable: boolean = true;

  massiveDownload$ = this.massiveDownload.asObservable();

  private jobExternalStatus = new Subject<string>();

  jobExeternal = this.jobExternalStatus.asObservable();

  constructor(
    private http: HttpClient,
    private sessionService: SessionService,
  ) { }

  downloadPdf(id: number): Observable<any> {
    // employer/curricula
    return this.http.get(
      `${environment.baseUrlWs}${environment.wsVerison}employer/curricula/${id}/cv`,
      { responseType: "arraybuffer" as "json" }
    );
  }

  async downloadMassive(
    jobId: number,
    filters: any = null,
    version: string = "v5"
  ) {
    return new Promise(async (resolve, reject) => {
      this.massiveDownload.next({
        loading: true,
        label: "Preparing ...",
      });
      // let stored = this.sessionService.get('candidates_filters') ? JSON.parse(this.sessionService.get('candidates_filters')) : {};

      // let sanitizedFilters = JSON.parse(JSON.stringify(stored));
      // if(sanitizedFilters['job_offers_id']){ sanitizedFilters['job_offers_id'] = sanitizedFilters['job_offers_id'].value; }
      // if(sanitizedFilters['languages_id']){ sanitizedFilters['languages_id'] = Number(sanitizedFilters['languages_id'].value); }
      // if(sanitizedFilters['language_level']){ sanitizedFilters['language_level'] = Number(sanitizedFilters['language_level'].value); }
      // if(sanitizedFilters['cities_ids'] && sanitizedFilters['cities_ids'][0]){ sanitizedFilters['cities_ids'][0] = sanitizedFilters['cities_ids'][0].id; }
      // if(sanitizedFilters['universities_ids'] && sanitizedFilters['universities_ids'][0]){ sanitizedFilters['universities_ids'][0] = sanitizedFilters['universities_ids'][0].id; }
      // if(sanitizedFilters['faculty_tags'] && sanitizedFilters['faculty_tags'][0]){ sanitizedFilters['faculty_tags'][0] = sanitizedFilters['faculty_tags'][0].id; }
      // if(sanitizedFilters['tags_ids'] && sanitizedFilters['tags_ids'][0]) {
      //   sanitizedFilters['tags_ids'][0] = sanitizedFilters['tags_ids'][0].id;
      // } else {
      //   delete sanitizedFilters['tags_ids'];
      // }
      // if(sanitizedFilters['skills_ids'] && sanitizedFilters['skills_ids'][0]){ sanitizedFilters['skills_ids'][0] = sanitizedFilters['skills_ids'][0].id; }
      const candidates: CandidatesEntityModel =
        await this.getCurriculaJobOfferByVersion(
          jobId,
          version,
          0,
          500,
          filters
        ).toPromise();

      const totCandidates = candidates.response.list.length;
      let candidatesId: any[] = [];

      ClevertapEventsService.emitEvent("downloadCVs", {
        total: candidates.response.list.length,
      });

      candidates.response.list.map((c) =>
        candidatesId.push({
          call: this.downloadPdf(Number(c.id)),
          fileName: `${c.id}-${c.User.name}-${c.User.surname}`,
        })
      );

      let results: any[] = [];

      for (const c of candidatesId) {
        const result = await new Promise((resolve, reject) => {
          this.massiveDownload.next({
            label: `Downloading ${results.length + 1} of ${totCandidates} ...`,
            loading: true,
          });
          return c.call
            .toPromise()
            .then((r) => resolve(r))
            .catch((e) => resolve(null));
        });
        if (result) {
          results.push({
            file: result,
            fileName: c.fileName,
          });
        }
      }

      if (results.length > 0) {
        this.massiveDownload.next({
          label: `${totCandidates} downloaded ...`,
          loading: true,
        });
        let zip = new JSZip();
        for (let i = 0; i < results.length; i++) {
          zip.file(
            `${results[i].fileName}.pdf`,
            new Blob([results[i].file], { type: "application/pdf" }),
            {}
          );
        }

        this.massiveDownload.next({
          label: `Starting generating Zip File ...`,
          loading: true,
        });
        const that = this;
        zip
          .generateAsync({ type: "blob" })
          .then(function (content) {
            FileSaver.saveAs(content, "pdf-cv-export.zip");
            that.massiveDownload.next({
              label: `Download`,
              loading: false,
            });
            resolve(true);
          })
          .catch((e) => {
            that.massiveDownload.next({
              label: `Download`,
              loading: false,
            });
            reject();
          });
      }
    });
  }

  getAll(page?: number): Observable<any> {
    let queryParams = "";
    if (page) {
      queryParams += "?page=" + page;
    }
    return this.http.get<any[]>(
      environment.baseUrlWs +
      environment.wsVerison +
      "employer/jobs/" +
      queryParams
    );
  }

  public getJobsV3(page?: number): Observable<V3JobsResponse> {
    const url: string = `${environment.baseUrlWs}v3/employer/jobs/`;
    let params = new HttpParams();
    params = page ? params.append("page", String(page)) : params;
    // if (page) {
    //   params = params.append("page", String(page));
    // }
    return this.http.get(url, { params: params }) as Observable<V3JobsResponse>;
  }

  getList(only_internal = false): Observable<any> {
    return this.http.get<any[]>(
      environment.baseUrlWs +
      environment.wsVerison +
      "employer/jobs-list" +
      (only_internal ? "?only_internal=true" : "")
    );
  }

  search(position?: string): Observable<any> {
    let queryParams = "";
    if (position) {
      queryParams += "?position=" + position;
    }
    return this.http.get<any[]>(
      environment.baseUrlWs +
      environment.wsVerison +
      "employer/jobs/" +
      queryParams
    );
  }

  getById(id: number): Observable<JobOffer> {
    return this.http.get<JobOffer>(
      environment.baseUrlWs + environment.wsVerison + "employer/jobs/" + id
    );
  }

  update(jobOffer: JobOffer, jobForm: any): Observable<any> {
    return this.http.put(
      environment.baseUrlWs +
      "v2/"
      +
      "employer/jobs/" +
      jobOffer.id,
      jobForm
    );
  }

  create(jobOffer: JobOffer, jobForm: any): Observable<any> {
    return this.http.post(
      environment.baseUrlWs + environment.wsVerison + "employer/jobs/",
      jobForm,
      {}
    );
  }

  new(data: FormData): Observable<any> {
    // const body: FormData = new FormData();
    const url: string = `${environment.baseUrlWs}${"v3/"}employer/jobs`;
    return this.http.post(url, data);
  }

  retrieve(id: number): Observable<any> {
    const url: string = `${environment.baseUrlWs
      }${"v3/"}employer/jobs/retrieve-detail/${id}`;
    return this.http.get(url).pipe(
      // tap((response) => console.log(response)),
      map((res: any) => {
        return {
          ...res,
          expiration_date: res.expiration_date
            ? moment(res.expiration_date).format(DP_FORMAT)
            : null,
          geolocations: res.Location
            ? res.Location.map((g: any) => {
              return { id: g.id, name: g.formattedAddress };
            })
            : [],
        };
      })
      // tap((response) => console.log(response)),
    );
  }

  updateState(id: number): Observable<any> {
    const url: string = `${environment.baseUrlWs}v1/employer/jobs/${id}/update-state`;
    return this.http.put(url, {});
  }

  updateExpirationDate(id: number, expiration_date: string): Observable<any> {
    const url: string = `${environment.baseUrlWs}v1/employer/jobs/${id}/update-expiration-date`;
    return this.http.put(url, { expiration_date: expiration_date });
  }

  getCurricula(
    jobs_id: number,
    page?: number,
    size?: number,
    body = {},
    tab = "all"
  ): Observable<Array<JobOffer>> {
    let query = "?page=0";
    if (page) {
      query = "?page=" + page;
    }
    if (size) {
      query += "&size=" + size;
    }
    query += "&tab=" + tab;
    return this.http.post<Array<JobOffer>>(
      environment.baseUrlWs +
      "v2/employer/jobs/" +
      jobs_id +
      "/curricula" +
      query,
      body
    );
  }

  getCurriculaJobOffer(
    jobOffersId: number,
    page?: number,
    limit?: number,
    body: any = {}
  ): Observable<CandidatesEntityModel> {
    const url: string = `${environment.baseUrlWs}v3/employer/jobs/${jobOffersId}/curricula`;
    let query_params: HttpParams = new HttpParams();
    query_params = query_params.append("page", String(page || 0));
    query_params = query_params.append("limit", String(limit || 20));

    // if (params) {
    //   // query_params = {...query_params, ...params} as HttpParams;
    //   for (const key in params) {
    //     // console.log(`${key}: ${user[key]}`);
    //     query_params = query_params.append(`${key}`, `${params[key]}`);
    //   }
    // }

    return this.http.post(url, body, {
      params: query_params,
    }) as Observable<CandidatesEntityModel>;
  }

  getCurriculaJobOfferV4(
    jobOffersId: number,
    page?: number,
    limit?: number,
    body: any = {}
  ): Observable<CandidatesEntityModel> {
    const url: string = `${environment.baseUrlWs}v5/employer/jobs/${jobOffersId}/curricula`;
    let query_params: HttpParams = new HttpParams();
    query_params = query_params.append("page", String(page || 0));
    query_params = query_params.append("limit", String(limit || 20));

    // if (params) {
    //   // query_params = {...query_params, ...params} as HttpParams;
    //   for (const key in params) {
    //     // console.log(`${key}: ${user[key]}`);
    //     query_params = query_params.append(`${key}`, `${params[key]}`);
    //   }
    // }

    return this.http.post(url, body, {
      params: query_params,
    }) as Observable<CandidatesEntityModel>;
  }

  getCurriculaJobOfferByVersion(
    jobOffersId: number,
    version: string = "v4",
    page?: number,
    limit?: number,
    body: any = {}
  ): Observable<CandidatesEntityModel> {
    const url: string = `${environment.baseUrlWs}${version}/employer/jobs/${jobOffersId}/curricula`;
    let query_params: HttpParams = new HttpParams();
    query_params = query_params.append("page", String(page || 0));
    query_params = query_params.append("limit", String(limit || 20));
    return this.http.post(url, body, {
      params: query_params,
    }) as Observable<CandidatesEntityModel>;
  }

  deleteJobOffer(id: number) {
    return this.http.delete(
      environment.baseUrlWs + environment.wsVerison + "employer/jobs/" + id
    );
  }

  externalCheck(version: string) {
    this.jobExternalStatus.next(version);
  }

  getActiveJobOffersStatus() {
    return this.http.get(
      environment.baseUrlWs +
      environment.wsVerison +
      "employer/common/job-offers-status"
    );
  }

  changeApplicationProcessStatus(id: number, process_status: string) {
    return this.http
      .put(
        environment.baseUrlWs +
        environment.wsVerison +
        "employer/jobs/application/" +
        id +
        "/process-status",
        {
          process_status,
        }
      )
      .toPromise();
  }

  getAllApplications(userId: number): Observable<ApplicationEntityModel[]> {
    const url: string = `${environment.baseUrlWs}v3/employer/jobs/get-applications/${userId}`;
    return this.http.get(url) as Observable<ApplicationEntityModel[]>;
  }
}
